export const filterPlansByRegistrationType = (plans, registrationType) => {
    let filterPlans = plans 
    if(registrationType === 4 || registrationType === 5) {
        filterPlans = filterPlans.filter(filterPlan => filterPlan.group === 'Pro')
    }
    return filterPlans
}